









































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import { State } from 'vuex-class';
import ImportModal from '../components/modals/importModal.vue';
import ShiftCell from '../components/shiftCell.vue';
import { WeekDays } from '@/config/map.conf';
import AddMemberModal from '../components/modals/addMemberModal.vue';
import MemberCell from '../components/memberCell.vue';
import { lxReportClick } from '@/utils/directive/lxanaly';
import { OncallReportMap } from '@/config/lx.conf';

import { fetchRgAdmins, switchOncall } from '@/utils/business';
import type { Awaited } from '@/utils/type-utils';

const TODAY: Date = new Date(new Date().setHours(0, 0, 0, 0));
// 可查看的最早时间为23年4月
const START_DATE: Date = new Date(2023, 3, 0);
@Component({
    components: {
        ImportModal,
        ShiftCell,
        AddMemberModal,
        MemberCell
    }
})
export default class OncallInfoTable extends Vue {
    @State(state => state.cti.env)
    env: string;
    @State(state => state.cti.userInfo.username)
    userName: string;

    dayInWeekMap: CommonTypes.mapObject = WeekDays;
    dateCols: CommonTypes.mapObject[] = [];
    tableData: CommonTypes.mapObject[] = [];
    oncallMembers: CommonTypes.mapObject[] = [];
    hourList: CommonTypes.mapObject = {};
    allShiftList: CommonTypes.mapObject[] = []; // RG组配置的班次list
    tableShiftList: CommonTypes.mapObject = {}; // 当前筛选范围下，table接口涉及到的班次列表（不一定等于allShiftList）
    allShiftWithWholeDayList: CommonTypes.mapObject[] = []; // 将“全天”拼进班次list中

    filterDate: Date = TODAY;
    filterType: 'MONTH' | 'WEEK' = 'WEEK';
    activeMis: string = '';
    activeMisDate: string = '';

    showImportModal: boolean = false;
    showMemberModal: boolean = false;
    tableLoading: boolean = false;
    disablePreviousBtn: boolean = false;
    disableNextBtn: boolean = false;
    lastCloseAnnouncement: boolean = false;
    isSwitchModalVisible: boolean = false;

    rgAdmins: Awaited<ReturnType<typeof fetchRgAdmins>> = [];

    @Watch('filterDate', { immediate: true })
    onFilterDateChanged() {
        this.updateBtnDisableState();
    }

    created() {
        this.initFilter();
        this.getShifts();
        this.getCalendar();
        this.updateWholeTable();
        this.getRgAdmins();
    }
    mounted() {
        if (localStorage.closeAnnouncement === 'true') {
            this.lastCloseAnnouncement = true;
        }
    }

    updateWholeTable() {
        this.tableLoading = true;
        Promise.all([this.getOncallMembers(), this.getHourList()])
            .then(() => {
                this.getTableData();
            })
            .catch(() => {
                this.tableLoading = false;
            });
    }
    updateDateTable() {
        this.getCalendar();
        this.tableLoading = true;
        this.updateWholeTable();
    }

    async getRgAdmins() {
        this.rgAdmins = await fetchRgAdmins(this.rgId);
    }

    async getShifts() {
        const res = await api.oncallApi.getShifts(this.rgId);
        const { data, code } = res;
        if (code === 200 && data) {
            this.allShiftList = data.items || [];
            this.allShiftWithWholeDayList = this.allShiftList.concat({
                abbreviation: '值班',
                color: 'ALL'
            });
        }
    }
    async getHourList() {
        const res = await api.oncallApi.getOncallHour({
            rgId: [this.rgId],
            timestamp: this.filterDate.getTime(),
            timeType: this.filterType
        });
        const { data, code } = res;
        if (code === 200 && data) {
            this.hourList = data;
        }
    }

    async getOncallMembers() {
        try {
            const res = await api.oncallApi.getOncallMember({
                rgId: [this.rgId],
                timestamp: this.filterDate.getTime(),
                timeType: this.filterType
            });
            const { data, code } = res;
            if (code === 200 && data) {
                this.oncallMembers = data.items;
            }
        } catch (error) {
            console.log('error:', error);
        }
    }

    async getCalendar() {
        const res = await api.oncallApi.getOncallCalender({
            rgId: [this.rgId],
            timestamp: this.filterDate.getTime(),
            timeType: this.filterType,
            needHolidayInfo: true
        });
        const { data, code } = res;
        if (code === 200 && data) {
            this.dateCols = [].concat(data.items || []);
        }
    }
    async getTableData() {
        try {
            const res = await api.oncallApi.getOncallTable({
                rgId: [this.rgId],
                timestamp: this.filterDate.getTime(),
                timeType: this.filterType,
                needRgDetail: false
            });
            const { data, code } = res;
            if (code === 200 && data) {
                this.tableLoading = false;
                this.tableShiftList = data.shift || [];
                this.formatTableData(data.oncall || {});
            }
        } catch (error) {
            console.log('error:', error);
            this.tableLoading = false;
        }
    }
    // 获取到所有表格数据后，进行处理
    formatTableData(data) {
        this.tableData = [];
        // 按照member接口的顺序取数据
        this.oncallMembers.forEach(member => {
            const row: CommonTypes.mapObject = {};
            row.member = { ...member };
            row.hour = this.hourList[member.identify]?.toFixed(1);
            Object.keys(data[member.identify]).forEach(timestamp => {
                let dateType = null;
                const { dayOff, wholeDay, shift } = data[member.identify][timestamp][this.rgId];
                if (dayOff.dayOff) {
                    dateType = 'dayOff';
                } else if (dayOff.dayOffPending) {
                    dateType = 'dayOffPending';
                } else if (wholeDay.wholeDayOncall) {
                    dateType = wholeDay.offline ? 'wholeDayOffline' : 'wholeDay';
                } else {
                    dateType = shift?.length ? 'shift' : 'noShift';
                }
                if (shift && shift.length && shift[0].shiftId) {
                    data[member.identify][timestamp][this.rgId].shift = data[member.identify][timestamp][this.rgId].shift.map(shift => {
                        shift.color = this.tableShiftList[shift.shiftId].color;
                        shift.abbreviation = this.tableShiftList[shift.shiftId].abbreviation;
                        return shift;
                    });
                }
                data[member.identify][timestamp] = {
                    ...data[member.identify][timestamp][this.rgId],
                    type: dateType
                };
            });
            row.dateList = data[member.identify];
            this.tableData.push(row);
        });
    }
    formatShiftList(shift) {
        Object.keys(id => {
            this.allShiftList.push(shift[id]);
        });
    }
    // 计算左右按钮是否可点击
    updateBtnDisableState() {
        // 起始时间的年、月
        const startMonth = START_DATE.getMonth();
        const startYear = START_DATE.getFullYear();
        // 截止时间是下个月底，需要计算endDate的下个月的年、月
        const endNextDate = this.getPreviousOrNextMonth(this.endDate, 'next');
        const endMonth = endNextDate.getMonth();

        if (this.filterType === 'MONTH') {
            // 当前日期前一个月、后一个月的日期
            const nextDate = this.getPreviousOrNextMonth(this.filterDate, 'next');
            const nextMonth = nextDate.getMonth();

            const previousDate = this.getPreviousOrNextMonth(this.filterDate, 'previous');
            const previousMonth = previousDate.getMonth();
            const previousYear = previousDate.getFullYear();

            this.disableNextBtn = endMonth === nextMonth;
            // 需要考虑不同年的情况
            this.disablePreviousBtn = startMonth > previousMonth && startYear === previousYear;
        } else {
            // 一周前/一周后如果属于无法查看的月份，则不可点击
            const nextDate = this.getPreviousOrNextWeek(this.filterDate, 'next');
            const nextWeekMonth = nextDate.getMonth();

            const previousDate = this.getPreviousOrNextWeek(this.filterDate, 'previous');
            // const previousWeekMonth = previousDate.getMonth();
            // const previousWeekYear = nextDate.getFullYear();

            this.disableNextBtn = endMonth === nextWeekMonth;
            // 需要考虑不同年的情况
            this.disablePreviousBtn = previousDate.getTime() < START_DATE.getTime();
        }
    }
    // 查询某个日期前一周或者后一周的Date
    getPreviousOrNextWeek(date: Date, type: 'previous' | 'next') {
        // 为了兼容起止日期按周查看可能跨月的情况，不固定+-7，而是取上一个周六或者下一个周日【按照周日、周一、...、周六的顺序】
        // 按照上述方法，如果起始时间与上月的最后几天在同一周 or 截止时间与下月的最早几天在同一周，也能正常查看
        const targetDate = new Date(date.getTime());
        targetDate.setDate(targetDate.getDate() - targetDate.getDay() + (type === 'previous' ? -1 : 7));
        return targetDate;
    }
    // 查询某个日期前一月或者后一月的Date
    getPreviousOrNextMonth(date: Date, type: 'previous' | 'next') {
        const year = date.getFullYear();
        const month = date.getMonth(); // 真实月份-1
        const day = date.getDate();
        let finalYear = year;
        let finalMonth = type === 'previous' ? month - 1 : month + 1;
        let finalDay = day;
        if (finalMonth === -1) {
            // 一月的前一个月
            finalYear = year - 1;
            finalMonth = 11;
        } else if (finalMonth === 12) {
            // 十二月的后一个月
            finalYear = year + 1;
            finalMonth = 0;
        }
        // 获取下个月天数
        const newDays = new Date(finalYear, finalMonth, 1).getDate();
        if (day > newDays) {
            finalDay = newDays;
        }
        return new Date(finalYear, finalMonth, finalDay);
    }
    // 获取某一天所在周的起止日期
    getWeekStartEnd(date: Date) {
        // 获取当天是周几（0表示周日，1~6表示周一到周六）
        const dayOfWeek = date.getDay();

        // 计算当前周的起始日期
        const start = new Date(date.getFullYear(), date.getMonth(), date.getDate() - dayOfWeek);

        // 计算当前周的截止日期
        const end = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (6 - dayOfWeek));

        // 格式化日期输出
        const formatDate = date => {
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
        };

        return {
            start: formatDate(start),
            end: formatDate(end)
        };
    }

    /**
     * 新版值班表的日期选择范围
     */
    disabledDate(date: Date) {
        const currentYear = new Date().getFullYear();
        const nextYear = currentYear + 1;

        // 允许选择的最早日期是 START_DATE
        const isAfterStartDate = date.getTime() >= START_DATE.valueOf();

        // 允许选择的最晚日期是下一年的最后一天
        const endOfNextYear = new Date(nextYear, 11, 31).valueOf();
        const isBeforeEndOfNextYear = date.getTime() <= endOfNextYear;

        // 只允许选择 START_DATE 之后到下一年年底之间的日期
        return !(isAfterStartDate && isBeforeEndOfNextYear);
    }

    updateRouter() {
        this.$router
            .push({
                name: this.$route.name,
                query: {
                    ...this.$route.query,
                    filterType: this.filterType,
                    filterDate: this.filterDate.getTime().toString()
                }
            })
            .catch(e => e);
    }
    initFilter() {
        const { filterType, filterDate } = this.$route.query;
        this.filterDate = new Date(Number(filterDate || TODAY));
        this.filterType = filterType === 'MONTH' ? 'MONTH' : 'WEEK';
    }
    checkDate() {
        const currentYear = TODAY.getFullYear();
        const selectedYear = this.filterDate.getFullYear();
        if (this.filterType === 'MONTH') {
            const currentMonth = TODAY.getMonth();
            const selectedMonth = this.filterDate.getMonth();
            return selectedYear < currentYear || selectedMonth < currentMonth;
        } else {
            const currentWeek = this.getWeek(TODAY);
            const selectedWeek = this.getWeek(this.filterDate);
            return selectedYear < currentYear || selectedWeek < currentWeek;
        }
    }
    getWeek(date) {
        const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
        const pastDaysOfYear = (date.getTime() - firstDayOfYear.getTime()) / 86400000;
        return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
    }
    onDataChanged(type: 'previous' | 'next') {
        if (this.filterType === 'MONTH') {
            this.filterDate = this.getPreviousOrNextMonth(this.filterDate, type);
        } else {
            this.filterDate = this.getPreviousOrNextWeek(this.filterDate, type);
        }
        if (this.checkDate()) {
            lxReportClick(OncallReportMap.query_historical_oncall);
        }
        this.updateDateTable();
        this.updateRouter();
    }
    onPopoverClose() {
        this.activeMis = '';
    }
    onTypeChanged() {
        this.updateDateTable();
        this.updateBtnDisableState();
        this.updateRouter();
    }
    onDatePick() {
        if (this.checkDate()) {
            lxReportClick(OncallReportMap.query_historical_oncall);
        }
        this.updateDateTable();
        this.updateRouter();
    }
    onCellClose() {
        this.activeMisDate = '';
    }
    onCellClick(scope: any) {
        // 因为“过去时间不可点击”而disable的cell
        const isDisableDateCell = scope.cell.className.includes('table-column-cell-disable');
        // 因为“已删除值班人整行不可点击”而disable的row
        const isDisableMemberRow = scope.cell.parentNode.className.includes('table-row-disable');
        // const isDisableMemberRowDateCell = isDisableMemberRow && scope.cell.className.includes('table-column-cell-date') ||scope.cell.className.includes('table-column-cell-member');
        if (isDisableDateCell || isDisableMemberRow) {
            return;
        }
        if (scope.column.prop === 'member') {
            this.activeMis = scope.row.member.identify;
        } else if (scope.column.prop !== 'hour') {
            this.activeMisDate = scope.row.member.identify + scope.column.label;
        }
    }
    openImportModal() {
        lxReportClick(OncallReportMap.click_import_oncall);
        this.showImportModal = true;
    }
    backToToday() {
        this.filterDate = TODAY;
        this.updateDateTable();
        this.updateRouter();
    }
    addMember() {
        this.showMemberModal = true;
    }

    closeAnnouncement() {
        localStorage.closeAnnouncement = 'true';
        this.lastCloseAnnouncement = true;
    }

    rowClass({ row }) {
        // 已被删除的成员整行不可点击，class加在tr上
        return row.member.deleted ? 'table-row-disable' : '';
    }
    cellClass(scope) {
        if (scope.columnIndex === 0) {
            return `table-column-cell-member ${scope.row.member.identify}`;
        } else if (scope.columnIndex === 1) {
            return 'table-column-cell-hour';
        } else {
            const isWeekend = ['6', '7'].includes(scope.column.prop.split('_')[0]);
            // 过去时间整列不可点击、超过endDate整列不可点击，class加在td上
            const isDisableDate = Number(scope.column.label) < TODAY.getTime() || Number(scope.column.label) > this.endDate.getTime();
            return `table-column-cell-date${isWeekend ? ' table-column-cell-weekend' : ''} ${isDisableDate ? ' table-column-cell-disable' : ''}`;
        }
    }
    headerCellClass(scope) {
        if (scope.rowIndex === 0 && scope.columnIndex === 2) {
            return 'table-header-info';
        } else if (scope.rowIndex === 0 && scope.columnIndex === 1) {
            return 'table-header-hour';
        } else if (scope.rowIndex === 1) {
            const isWeekend = ['6', '7'].includes(scope.column.prop.split('_')[0]);
            return `table-header-date${isWeekend ? ' table-header-weekend' : ''}`;
        }
        return '';
    }

    switchToOldOncall() {
        switchOncall({ rgId: this.rgId, switchToNew: false });
    }

    jumpPage() {
        const url = this.$router.resolve({
            name: 'rg_oncall_rules',
            query: {
                rgId: `${this.rgId}`
            }
        });
        window.open(url.href, '_blank');
    }

    confirmSwitch() {
        this.switchToOldOncall();
        this.isSwitchModalVisible = false;
    }

    /**
     * 当前用户是否是当前rg组管理员.
     */
    get isRgAdmin() {
        const userInfo = this.rgAdmins.find(item => item.identify === this.userName);
        if (!userInfo) return false;
        return userInfo.role === 'RGADMIN';
    }

    /**
     * shiftCell 的最大结束日期.
     */
    get endDate() {
        // 可查看的最晚时间为后两年的最后一天
        const currentYear = new Date().getFullYear();
        const nextTwoYears = currentYear + 2;
        return new Date(nextTwoYears, 11, 31);
    }

    get ruleDateOptions() {
        return {
            disabledDate: this.disabledDate
        };
    }
    get tableHeaderDate() {
        return `${this.filterDate.getFullYear()}年${this.filterDate.getMonth() + 1}月`;
    }
    get dateFormatString() {
        const { start, end } = this.getWeekStartEnd(this.filterDate);
        return this.filterType === 'WEEK' ? `${start} ~ ${end}` : 'yyyy年MM月';
    }
    get disableImport() {
        return !this.allShiftList.length;
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }

    get showAnnouncement() {
        // 上次未关闭公告，且当前时间范围在上线日期所在月/周
        // 开始日期目前是12.31，从1.1开始查看，为了应对左右切换周的情况，需要对比8天
        const inSameMonth = this.filterType === 'MONTH' && this.filterDate.getMonth() === this.getPreviousOrNextMonth(START_DATE, 'next').getMonth();
        const inSameWeek = this.filterType === 'WEEK' && this.filterDate.getTime() - START_DATE.getTime() < 8 * 24 * 60 * 60 * 1000;
        return !this.lastCloseAnnouncement && (inSameMonth || inSameWeek);
    }
}
